const normalizeValues = (arr) => arr.map((el) => el.value).join();

export default (filters) => {
  const { device = [], countries = [], itemCategories = [], products = [] } = filters;
  const params = [
    {
      key: "d",
      value: normalizeValues(device),
    },
    {
      key: "p",
      value: normalizeValues(products),
    },
    {
      key: "c",
      value: normalizeValues(itemCategories),
    },
    {
      key: "r",
      value: normalizeValues(countries),
    },
  ];
  const returnObject = {};
  params.forEach((param) => {
    if (param.value) {
      returnObject[param.key] = param.value;
    }
  });

  // set item category filter to equal 'all' by default if no filter is selected
  returnObject.c = returnObject.c || "all";

  return returnObject;
};
